export default {
    name: 'numeric',
    validate(modelValue, viewValue /* , record, options */) {
        if (!viewValue) {
            return true;
        }
        return /^[(-]?\$?[\d,]+(\.\d+)?\)?$/.test(viewValue);
    },
};
